import React from 'react';
import Select from 'react-select';

const MosqueePicker = ({ data, callback, mosquee }) => {
    const handleChange = (item) => {
        callback(item.value);
    }

    return(
        <Select
        defaultValue={data.find((item) => item.value === mosquee)}
        placeholder="Réservez votre place pour la prière du Vendredi dans la Mosquée de votre choix"
        className="mb-3"
        options={data} 
        onChange={handleChange}
        />
    );
}

export default MosqueePicker;